import { combineReducers } from 'redux';

import verificationReport from './verificationreport/reducer';

export default combineReducers({
  verificationReport,
});



// WEBPACK FOOTER //
// ./src/pages/verificationreport/state/reducer.js